import { render, staticRenderFns } from "./businessIntelligenceDashboard.vue?vue&type=template&id=10d66ffe&"
import script from "./businessIntelligenceDashboard.vue?vue&type=script&lang=js&"
export * from "./businessIntelligenceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./businessIntelligenceDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d66ffe')) {
      api.createRecord('10d66ffe', component.options)
    } else {
      api.reload('10d66ffe', component.options)
    }
    module.hot.accept("./businessIntelligenceDashboard.vue?vue&type=template&id=10d66ffe&", function () {
      api.rerender('10d66ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/BiAnalysis/businessIntelligenceDashboard.vue"
export default component.exports